import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Radio } from "antd";
import { EUserRole, ServiceTemplateField, TRANSLATABLE_SERVICE_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { useTranslation } from "../../../../../../others/i18n.js";
import { getDisableStrategies } from "../../../../../../util/template/merge-strategies.js";
import { getFieldNameTranslated } from "../../../../../../util/template/translation.js";
import { FormFieldVisibilityWrapper, FormFieldVisibilityWrapperByCdn } from "../../formFieldVisibilityWrapper.js";
import { TemplateMetaDataExtendsStrategyFormField } from "../../templateMetaDataExtendsStrategyFormField.js";
/**
 * Form field for the is provider current site.
 * This field allows users to select if the service provider is the current website.
 *
 * @returns The form field component for is provider current site.
 */ function FormFieldServiceTemplateIsProviderCurrentSite({ options }) {
    const { t } = useTranslation();
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapperByCdn, {
        children: /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
            fieldNames: ServiceTemplateField.IsProviderCurrentWebsite,
            permissionCheck: {
                whenRole: EUserRole.Translator,
                roleWhiteList: TRANSLATABLE_SERVICE_TEMPLATE_ATTRIBUTES_LIST
            },
            children: /*#__PURE__*/ _jsx(Form.Item, {
                label: getFieldNameTranslated(ServiceTemplateField.IsProviderCurrentWebsite, t),
                extra: t("Choose 'Yes', if the website owner is responsible for data processing (e.g. self-hosted service)."),
                shouldUpdate: (prev, next)=>prev.extends?.identifier !== next.extends?.identifier,
                required: true,
                children: ({ getFieldValue })=>{
                    const extended = getFieldValue(TemplateMetaDataField.Extends);
                    return /*#__PURE__*/ _jsx(TemplateMetaDataExtendsStrategyFormField, {
                        extendsFieldName: ServiceTemplateField.IsProviderCurrentWebsite,
                        disableStrategies: getDisableStrategies(),
                        onKeepContent: extended && /*#__PURE__*/ _jsx(Radio.Group, {
                            defaultValue: Boolean(extended[ServiceTemplateField.IsProviderCurrentWebsite]),
                            options: options,
                            optionType: "button",
                            buttonStyle: "solid",
                            disabled: true
                        }),
                        children: /*#__PURE__*/ _jsx(Form.Item, {
                            name: ServiceTemplateField.IsProviderCurrentWebsite,
                            noStyle: true,
                            children: /*#__PURE__*/ _jsx(Radio.Group, {
                                options: options,
                                optionType: "button",
                                buttonStyle: "solid"
                            })
                        })
                    });
                }
            })
        })
    });
}
export { FormFieldServiceTemplateIsProviderCurrentSite };
